import Layout from '@components/Layout';
import Login from '@containers/Login';
import { middlewareLogin } from '@helpers/middleware';
import { ITitle } from '@interfaces/ITitle';
import { actionGetDetailInstanceDomain } from '@libraries/api/instance/instance.function';
import { IInstanceDetail } from '@libraries/api/instance/instance.types';
import type { NextPage, NextPageContext } from 'next';

interface IProps extends ITitle {
  detial: IInstanceDetail;
}
const LoginPage: NextPage<IProps> = ({ title, detail }): JSX.Element => {
  return (
    <Layout title={title} isAuthLayout p="0">
      <Login detail={detail} />
    </Layout>
  );
};

export async function getServerSideProps(context: NextPageContext) {
  const host = context.req?.headers.host;
  const detail = await actionGetDetailInstanceDomain(host, context);

  return middlewareLogin(context, {
    title: 'Login',
    host: host || '',
    detail: detail || null,
  });
}
export default LoginPage;
